import { useState } from "react"



export const Button = ({text, onClick, color = "#555555", className}) => {
    const [hovered, setHovered] = useState(false);

    const buttonStyle = {
        border: "none",
        backgroundColor: hovered ?  "#888888" : color,
        color: "#fff",
        fontWeight: "600",
        fontSize: "14px",
        fontFamily: "inherit",
        padding: "0 20px",
        borderRadius: "8px",
        cursor: "pointer",
        alignSelf: "flex-start", // Fixes flexbox stretching issues
        flex: "0 0 auto",
        height: "50px",
        transition: "background-color 0.12s, opacity 0.12s",
      };

    return(
        <button type="button" className={className} style={buttonStyle} onClick={onClick} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}  >
            {text}
        </button>
    )
}

export default Button